import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";
import { Announcement } from "../apiSlice/announcementSlice";

export const getAnnouncements = createAsyncThunk(
  "getAnnouncements",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.announcements);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
export const getATCAnnouncements = createAsyncThunk(
  "getAnnouncements",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.announcementsAtc);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const addAnnouncement = createAsyncThunk(
  "addAnnouncement",
  async (
    { data, popup }: { data: Announcement; popup: any },
    { dispatch, rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.put(EndPoints.announcements, data);
      popup.close();
      dispatch(getAnnouncements());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
export const updateAnnouncement = createAsyncThunk(
  "updateAnnouncement",
  async (
    { data, popup }: { data: Announcement; popup: any },
    { dispatch, rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.announcements}/${data.id}`,
        data
      );
      popup.close();
      dispatch(getAnnouncements());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteAnnouncement = createAsyncThunk(
  "delete/products",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(
        `${EndPoints.announcements}/${id}`
      );
      dispatch(getAnnouncements());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
